import { render, staticRenderFns } from "./ProgramUpdate.vue?vue&type=template&id=5020eea3&"
import script from "./ProgramUpdate.vue?vue&type=script&lang=js&"
export * from "./ProgramUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports